var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIl(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 55,
    height: 41,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.6 0h53.5v40.1H.6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56 40.1H-1.3V0H56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0038b8",
    d: "M56 9H-1.3V3.8H56zm0 27.5H-1.3v-5.3H56zM18.2 14.9l8.6 15L35.6 15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25.2 24.9 1.6 2.8 1.7-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0038b8",
    d: "m18.2 25.1 8.6-15 8.8 15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25.2 15 1.6-2.8 1.7 2.8zm-3.4 6.2L20 24.1h3.2zM20 16h3.2l-1.4 3zm11.8 5.3 1.7 2.8h-3.3zm1.6-5.3h-3.2l1.8 3zm-9 0-2.1 4 2.2 4h4.2l2.5-4-2.4-4z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIl);
export default __webpack_public_path__ + "static/media/il.7151c65ea29fc5afdc0a0826b071c29d.svg";
export { ForwardRef as ReactComponent };